import { Pipe, PipeTransform } from '@angular/core';

/**
 * Converts "days" (number, can be fractional) into a readable duration:
 * - < 60 mins  -> "29 mins"
 * - < 24 hrs   -> "4.0 hrs"
 * - >= 1 day   -> "4 days 3 hrs" (optionally with mins)
 */
@Pipe({
   name: 'durationFromDays',
   standalone: true
})
export class DurationFromDaysPipe implements PipeTransform {
   transform(
      days: number | null | undefined,
      options?: { showMinutes?: boolean }
   ): string {
      if (days === null || days === undefined) return '-';
      if (Number.isNaN(days) || days <= 0) return '-';

      const showMinutes = options?.showMinutes ?? false;

      const totalMinutes = Math.round(days * 24 * 60);

      if (totalMinutes < 1) return '< 1 min';

      // < 60 minutes => mins
      if (totalMinutes < 60) {
         return `${totalMinutes} mins`;
      }

      // < 24 hours => hours (1 decimal)
      if (totalMinutes < 24 * 60) {
         const hrs = totalMinutes / 60;
         return `${hrs.toFixed(1)} hrs`;
      }

      // >= 1 day => days + hours (+ optional mins)
      const d = Math.floor(totalMinutes / (24 * 60));
      const rem = totalMinutes % (24 * 60);
      const h = Math.floor(rem / 60);
      const m = rem % 60;

      let out = `${d} day${d === 1 ? '' : 's'}`;
      if (h > 0) out += ` ${h} hr${h === 1 ? '' : 's'}`;
      if (showMinutes && m > 0) out += ` ${m} min${m === 1 ? '' : 's'}`;

      return out;
   }
}
